module.exports = __webpack_public_path__ + "img/keypad-seven.4aa2518b.svg";